import React from 'react'
import { CallToAction } from 'components/CallToAction'
import { SignupCTA } from 'components/SignupCTA'

export const LPCTA = () => {
    return (
        <>
            <br />
            <div className="flex flex-col items-center justify-center gap-2 md:flex-row xl:gap-4">
                <SignupCTA width="56" text="Try iCloudReady today" />
                <CallToAction type="outline" width="56" to="/book-a-meeting">
                    Schedule a demo
                </CallToAction>
            </div>
            <br />
        </>
    )
}
